module.exports = __webpack_public_path__ + "static/img/banner3.b7a26bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 1